export enum SigningProvider {
  NorwegianBankID = 'NBID',
  SwedishBankID = 'SBID',
  DanishMitId = 'MITID-CPR',
}
